import React from "react";
const contextOptions = {
    locale: undefined,
    isRTL: false
};
const context = React.createContext(contextOptions);
export default context;
